import PropTypes from 'prop-types';
import { ItemsAll } from '../../components/Views/ItemsAll';
import { getSeoData, getValueFromObject } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import {
  setAdriverSelectedCity,
  setCurrentState,
  setSearchSort
} from '../../actions';
import { BUILDING_TYPE_ID, Cities } from '../../utils/helpers/constants';
import { getStaticData } from '../../utils/helpers/getStaticData';
import {
  getSortDataForTransformationsQuery,
  searchItemsQuery
} from '../../api/queries';
import { ItemConnectionSort } from '../../graphql/types';

const App = ({ sortingValue, ...rest }) => (
  <ItemsAll {...{ sortingValue, ...rest }} />
);

App.getInitialProps = async ({ apolloClient, asPath, req, query, store }) => {
  const [dataForTransform, seoData] = await Promise.all([
    apolloClient.query({ query: getSortDataForTransformationsQuery }),
    getSeoData(apolloClient, asPath, req),
    getStaticData(apolloClient)
  ]);

  const sortingValue = query.sorting;

  const sorting =
    getValueFromObject(dataForTransform.data.sort, sortingValue, 'name') ||
    ItemConnectionSort.BumpedAtDesc;

  const storedFormState = store.getState().searchForm.currentState;

  store.dispatch(
    setCurrentState({
      ...storedFormState,
      city_id: Cities.Baku.id,
      category_id: BUILDING_TYPE_ID.FLAT_ALL,
      leased: 'false',
      sorting
    })
  );

  store.dispatch(setAdriverSelectedCity(Cities.Baku.az));

  store.dispatch(setSearchSort(sorting || ItemConnectionSort.BumpedAtDesc));

  const itemsQueryVariables = {
    first: 16,
    filter: {},
    sort: sorting || ItemConnectionSort.BumpedAtDesc
  };

  await apolloClient.query({
    query: searchItemsQuery,
    variables: itemsQueryVariables
  });

  return { sortingValue: sorting, seoData, isItemsAllPage: true };
};

App.propTypes = {
  sortingValue: PropTypes.string,
  seoData: PropTypes.object,
  isItemsAllPage: PropTypes.bool
};

App.getLayout = (page, pageProps) => (
  <Layout isBackgroundBanner pageProps={pageProps}>
    {page}
  </Layout>
);

export default App;
